import { createActionCreator } from "common/ReduxUtils";

export enum PaginationActionTypes {
  UPDATE_PAGE = "UPDATE_PAGE",
}

export const updatePage = createActionCreator<number>(PaginationActionTypes.UPDATE_PAGE, "page");
